import { createPartnerConfig } from '../base/PartnerConfigFactory';

import Parameters from './Parameters';
import validate from './validate';

export const name = 'Bright';

const config = createPartnerConfig({
    ParametersComponent: Parameters,
    buildPayloadConfig: {
        extendPayload: (basePayload, values) => {
            const {
                file_rate,
                financial_work_cost_month,
                financier_product_name,
                opex,
                opex_active,
                opex_cost_ranges_kw,
                opex_costing_type,
                opex_percentage_increase,
                opex_periodicity,
                percentage_work_funding,
                work_cost_active,
                work_cost_ranges,
            } = values;

            const extended = {
                ...basePayload,
                financial_work_cost_month,
                financier_product_name,
                opex,
                opex_active,
                opex_cost_ranges_kw: JSON.stringify(opex_cost_ranges_kw),
                opex_costing_type,
                opex_percentage: opex_percentage_increase,
                opex_periodicity,
                percentage_work_funding,
                work_cost_active,
                work_cost_ranges: JSON.stringify(work_cost_ranges),
            };

            // Agregar file_rate si existe
            if (Array.isArray(file_rate) && file_rate.length > 0) {
                extended.file_rate = file_rate[0];
            }

            return extended;
        },
    },
    buildPrepareValuesConfig: {
        extendPrepareValues: (baseValues, values) => ({
            ...baseValues,
            dealer_fee: values.parameters[0]?.dealer_fee,
            file_rate: values.parameters[0]?.file_rate || null,
        }),
    },
    customAlgorithms: [
        { label: 'Leasing with Solver', value: 'solver_payment' },
    ],
    name,
    validationConfig: { schema: validate },
});

export default { ...config, name };
